// extracted by mini-css-extract-plugin
module.exports = {"container":"NotesWidget_container__2ytdM","containerPreview":"NotesWidget_containerPreview__3hPav","title":"NotesWidget_title__899m7","desc":"NotesWidget_desc__8k_Nd"};